import { invoiceStatuses } from "astrid-firestore/src/api/invoices/invoiceStatuses";

export const invoiceStatusColors = {
	[invoiceStatuses.UNPAID]: "black",
	[invoiceStatuses.PAID]: "green",
};
